export const API = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIME_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'b2cdedfd-9609-403e-9118-a28fe7ce8ebe';
export const MODAL_CLOSE_SEC = 2.5;
